import React from "react";
import { ChatReaderComponentProps } from "../types";
import { FileInput as FInput } from "reader-common";

export function FileInput(props: ChatReaderComponentProps<"FILE">) {

    return (
        <FInput
            value={ props.value }
            onChange={ props.onChange }
            storeFile={ props.storeFile }
            config={ props.config }
            autoFocus={ props.autoFocus }
            allowedExtensions={ props.inputField.allowedExtensions }
        />
    )

}
